import React from 'react';
import { mockData } from '../mockData';
import { TrendingUp, Target, Bell, FileText, BarChart3, Download, ExternalLink } from 'lucide-react';
import '../styles/HomePage.css';

const iconMap = {
  TrendingUp: TrendingUp,
  Target: Target,
  Bell: Bell,
  FileText: FileText,
  BarChart3: BarChart3
};

const HomePage = () => {
  const handleDownload = (store) => {
    const url = store === 'google' ? mockData.appStoreLinks.googlePlay : mockData.appStoreLinks.appStore;
    window.open(url, '_blank');
  };

  return (
    <div className="home-page">
      {/* Hero Section with Magnificent Logo */}
      <section className="hero-section">
        <div className="hero-content">
          {/* Logo Showcase */}
          <div className="hero-logo-container">
            <div className="logo-glow-ring"></div>
            <img 
              src={mockData.logo.url} 
              alt={mockData.logo.alt}
              className="hero-logo"
            />
          </div>
          
          <h1 className="hero-title">{mockData.hero.title}</h1>
          <p className="hero-subtitle">{mockData.hero.subtitle}</p>
          
          <div className="hero-cta">
            <button className="btn-primary" onClick={() => handleDownload('google')}>
              <Download size={20} />
              Google Play
            </button>
            <button className="btn-primary" onClick={() => handleDownload('apple')}>
              <Download size={20} />
              App Store
            </button>
          </div>
        </div>
      </section>

      {/* Tagline Section */}
      <section className="tagline-section">
        <div className="tagline-container">
          <p className="tagline-text">
            Sentinel is an AI that watches global markets and explains what traders should pay attention to.
          </p>
        </div>
      </section>

      {/* What Sentinel Does */}
      <section className="section-container">
        <h2 className="section-title">What Sentinel Does</h2>
        <div className="features-grid">
          {mockData.features.map((feature, index) => (
            <div key={index} className="feature-item">
              <div className="feature-bullet"></div>
              <p className="feature-text">{feature}</p>
            </div>
          ))}
        </div>
      </section>

      {/* How It Works */}
      <section className="section-container section-alt">
        <h2 className="section-title">How It Works</h2>
        <div className="steps-container">
          {mockData.howItWorks.map((step) => (
            <div key={step.step} className="step-card">
              <div className="step-number">{step.step}</div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Key Features */}
      <section className="section-container">
        <h2 className="section-title">Key Features</h2>
        <div className="key-features-grid">
          {mockData.keyFeatures.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div key={index} className="feature-card">
                <div className="feature-icon">
                  <IconComponent size={32} />
                </div>
                <h3 className="feature-card-title">{feature.title}</h3>
                <p className="feature-card-description">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </section>

      {/* Asset Classes */}
      <section className="section-container section-alt">
        <h2 className="section-title">Multiple Asset Classes</h2>
        <div className="asset-classes">
          <div className="asset-category">
            <h4 className="asset-label">Crypto</h4>
            <p className="asset-list">{mockData.assetClasses[0]}</p>
          </div>
          <div className="asset-category">
            <h4 className="asset-label">Forex</h4>
            <p className="asset-list">{mockData.assetClasses[1]}</p>
          </div>
          <div className="asset-category">
            <h4 className="asset-label">Macro</h4>
            <p className="asset-list">{mockData.assetClasses[2]}</p>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="cta-section">
        <h2 className="cta-title">Start Trading Smarter Today</h2>
        <p className="cta-subtitle">Download Market Sentinel AI and get real-time trading intelligence</p>
        <div className="cta-buttons">
          <button className="btn-primary" onClick={() => handleDownload('google')}>
            <Download size={20} />
            Google Play
          </button>
          <button className="btn-primary" onClick={() => handleDownload('apple')}>
            <Download size={20} />
            App Store
          </button>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
